import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

import { blink, sheen } from './keyframes';

const MOBILE = '@media (max-width: 960px)';

export const Wrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 50rem;
  gap: 7.2rem;
  align-items: center;
  padding: 8.8rem 7.2rem 9.6rem;

  ${MOBILE} {
    grid-template-columns: 1fr;
    padding: 4rem 2.4rem 4.8rem;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  align-self: flex-start;
  background: ${LandingHero.badgeBg};
  border: 0.1rem solid ${LandingHero.badgeBorder};
  box-shadow: 0 0 3rem -0.8rem ${LandingHero.badgeShadow};
  border-radius: 999rem;
  padding: 0.9rem 1.8rem;
`;

export const BadgeDot = styled.div`
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 999rem;
  background: ${LandingHero.liveDot};
  box-shadow: 0 0 1rem ${LandingHero.liveDot};
  animation: ${blink} 1.8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const BadgeLabel = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
  color: ${LandingHero.badgeText};
`;

export const Heading = styled.div`
  font-family: ${HERO_FONT_DISPLAY};
  font-weight: 800;
  font-size: 5.2rem;
  line-height: 1.04;
  letter-spacing: -0.18rem;
  color: ${LandingHero.textPrimary};

  em {
    font-style: normal;
    background: ${LandingHero.pro.arrowGradient};
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  ${MOBILE} {
    font-size: 3.4rem;
    letter-spacing: -0.08rem;
  }
`;

export const Description = styled.div`
  font-size: 1.7rem;
  line-height: 1.6;
  color: ${LandingHero.textMuted};
  max-width: 56rem;

  strong {
    font-weight: 800;
    color: ${LandingHero.textBody};
  }
`;

export const CtaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-wrap: wrap;
`;

export const PrimaryCta = styled.button`
  position: relative;
  overflow: hidden;
  background: ${LandingHero.ctaGradient};
  color: ${LandingHero.ctaText};
  font-size: 1.6rem;
  font-weight: 800;
  padding: 1.8rem 3.4rem;
  border-radius: 1.4rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  box-shadow:
    0 1.4rem 3.4rem -1rem ${LandingHero.ctaShadow},
    inset 0 0.1rem 0 ${LandingHero.ctaInsetHighlight};
  transition: transform 0.25s ease;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${LandingHero.ctaSheen},
      transparent
    );
    animation: ${sheen} 3.6s ease-in-out infinite;
  }

  &:hover {
    transform: translateY(-0.2rem);
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;

export const SecondaryCta = styled.button`
  background: transparent;
  color: ${LandingHero.textBody};
  font-size: 1.6rem;
  font-weight: 700;
  padding: 1.7rem 3rem;
  border-radius: 1.4rem;
  border: 0.1rem solid ${LandingHero.ghostBorder};
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.25s ease, background-color 0.25s ease, transform 0.25s ease;

  &:hover {
    color: ${LandingHero.textPrimary};
    border-color: ${LandingHero.ghostBorderHover};
    background: ${LandingHero.ghostBgHover};
    transform: translateY(-0.1rem);
  }
`;

export const FeatureStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  border-top: 0.1rem solid ${LandingHero.band.border};

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-top: 2.2rem;
`;

export const FeatureTitle = styled.div`
  font-size: 1.7rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const FeatureDescription = styled.div`
  font-size: 1.35rem;
  line-height: 1.45;
  color: ${LandingHero.textMuted};
`;
